function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCompassDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 10.583 10.583",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m5.2503 10.424c-.010127-.016498-.16338-.49774-.34054-1.0694-.93948-3.0318-.88093-2.8999-1.3448-3.0307-.36549-.10308-3.1959-.96354-3.3283-1.0118-.18116-.066057-.21337-.11326-.099946-.14645 1.3931-.40763 3.6749-1.1166 3.7482-1.1646.14693-.096271.22075-.27263.53702-1.2829.93204-2.9774.86519-2.8334 1.0441-2.2488.42814 1.399.9761 3.1167 1.0464 3.2802.10273.23894.11917.24727 1.0305.52209 1.8571.56004 2.9275.8982 2.9664.93714.045437.045434-.33977.17518-2.5581.8616-1.5656.48445-1.3199.12918-2.2508 3.2541-.30379 1.0198-.38183 1.2105-.45005 1.0996zm.41598-3.5514c.99453-.2262 1.5483-1.3585 1.1185-2.2872-.46889-1.0132-1.7569-1.2853-2.5609-.541-1.2435 1.1513-.19802 3.2013 1.4424 2.8282z",
    style: {
      fill: "#073c7a"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCompassDark);
export default __webpack_public_path__ + "static/media/icon_compass_dark.a0cb8ffa8322681bff69ee05460e930a.svg";
export { ForwardRef as ReactComponent };